import { Globe } from 'lucide-react';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'bg', label: 'Bulgarian', flag: '🇧🇬' },
  { code: 'de', label: 'German', flag: '🇩🇪' },
  { code: 'fr', label: 'French', flag: '🇫🇷' },
  { code: 'es', label: 'Spanish', flag: '🇪🇸' },
  { code: 'it', label: 'Italian', flag: '🇮🇹' },
  { code: 'pt', label: 'Portuguese', flag: '🇵🇹' },
  { code: 'pl', label: 'Polish', flag: '🇵🇱' },
  { code: 'ru', label: 'Russian', flag: '🇷🇺' },
  { code: 'tr', label: 'Turkish', flag: '🇹🇷' },
  { code: 'ro', label: 'Romanian', flag: '🇷🇴' },
  { code: 'el', label: 'Greek', flag: '🇬🇷' },
];

/**
 * Compact language picker — `select` styled as a small pill.
 * Use it next to every AI action button.
 */
export default function LanguagePicker({ value, onChange, size = 'sm', testid = 'language-picker' }) {
  const cls = size === 'xs'
    ? 'h-7 px-2 text-[11px]'
    : size === 'sm'
    ? 'h-8 px-2 text-xs'
    : 'h-9 px-3 text-sm';
  return (
    <label className={`inline-flex items-center gap-1.5 ${cls} rounded-full border border-border bg-background hover:border-[#1d4ed8]/40 cursor-pointer transition-colors`}>
      <Globe className="w-3 h-3 text-muted-foreground" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="bg-transparent outline-none cursor-pointer pr-1 appearance-none"
        data-testid={testid}
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </label>
  );
}
